import { useTranslation } from 'react-i18next';

export default function useBuilderTranslation() {
    return useTranslation('builder');
}